import type { Distance } from "@pdfking/math"

import type { BoxPointLists } from "#internal"

export const TranslatePoints = (
  offset_x: Distance,
  offset_y: Distance,
  points_list: BoxPointLists
): BoxPointLists =>
  points_list.map(points =>
    points.map(point => ({
      ...point,
      x: (offset_x + point.x) as Distance,
      y: (offset_y + point.y) as Distance,
    }))
  )
